import { Button, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserSelector from '../../../UserSelector/UserSelector';
import CommissionItemModel from './models/CommissionItemModel';

interface FixtureCommissionDetailProp {
    selectedItems: CommissionItemModel[],
    className?: string,
    onItemChange?: (selectedItem: CommissionItemModel[]) => void,
}

const FixtureCommissionDetail: React.FunctionComponent<FixtureCommissionDetailProp> = (props) => {
    const dispatch = useDispatch();

    return (
        <>
            <Grid>
                Commission Structure <span className='support-sheet-red-text'>Make sure the sum of commission equals 100</span>
            </Grid>
            {
                props.selectedItems.map((item: CommissionItemModel, index: number) => (
                    <Grid container>
                        <Grid item xs={5}>
                            <UserSelector
                                label='Broker'
                                className='cargo-input-component'
                                selectedUserId={item.brokerId}
                                onUserIdChange={(value: number, displayName: string) => {
                                    if (props.onItemChange) {
                                        let selectedItems = [...props.selectedItems];
                                        _.each(selectedItems, (item) => {
                                            if (item.index === index) {
                                                item.brokerId = value;
                                                item.brokerName = displayName;
                                            }
                                        });
                                        props.onItemChange(selectedItems);
                                    }
                                }}
                            >
                            </UserSelector>
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                label="Percent"
                                fullWidth
                                type='number'
                                value={item.percent}
                                onChange={(event) => {
                                    if (props.onItemChange) {
                                        let selectedItems = [...props.selectedItems];
                                        _.each(selectedItems, (item) => {
                                            if (item.index === index) {
                                                item.percent = parseInt(event.target.value);
                                            }
                                        });
                                        props.onItemChange(selectedItems);
                                    }
                                }}
                                className='cargo-input-component'
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                className='table-action-button'
                                onClick={() => {
                                    if (props.onItemChange) {
                                        props.selectedItems.splice(index, 1);
                                        props.onItemChange(props.selectedItems);
                                    }
                                }}
                                variant='text'
                            >
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </Button>
                        </Grid>
                    </Grid>
                ))
            }
            <Grid container>
                <Button
                    color="secondary"
                    variant='outlined'
                    onClick={() => {
                        let newItem = {
                            index: props.selectedItems.length,
                            brokerId: null,
                            brokerName: "",
                            percent: 0
                        } as CommissionItemModel;

                        let selectedItems = [...props.selectedItems, newItem];
                        if (props.onItemChange) {
                            props.onItemChange(selectedItems);
                        }
                    }}
                >
                    Add Share
                </Button>
            </Grid>
        </>
    )
};

export default FixtureCommissionDetail;